// @ts-ignore
import createClickStream from '@uchi/client-clickstream';

export enum ClickStreamVersion {
    Views = 8,
    Events = 11,
}

export const clickStream = (version: number) => createClickStream({
    host: process.env.REACT_APP_CLICKSTREAM_HOST,
    options: { version },
});